import { atom } from "jotai";
import { defaultComponentConfig } from "./defaultConfig";

import type { PopulatedComponentConfig } from "./types";

export const componentConfigAtom = atom<PopulatedComponentConfig>(
  defaultComponentConfig,
);
